import { useEffect, useState } from 'react'

export default function useTotallyEmptyList(params = {}, data, loaded) {
  const [firstLoad, setFirstLoad] = useState(true)
  const [totallyEmptyList, setTotallyEmpty] = useState(undefined)

  useEffect(() => {
    if (!firstLoad && totallyEmptyList === false) return

    setTotallyEmpty(!!(Object.keys(params).length === 0 && loaded && data?.length === 0))
  }, [params, data, loaded])

  useEffect(() => {
    if (!firstLoad || !loaded) return

    setFirstLoad(false)
  }, [loaded, firstLoad])

  return [totallyEmptyList, firstLoad]
}
